import { FC, memo, PropsWithChildren } from "react";

import { Box, Flex } from "@mantine/core";

import CollectionPreview, {
  CollectionPreviewProps,
} from "~/features/collections/forms/CreateCollectionMultistepForm/CollectionPreview";

const FormContentWithPreview: FC<
  PropsWithChildren<CollectionPreviewProps & { asQuickDropFlow?: boolean }>
> = ({ children, asQuickDropFlow = false, ...rest }) => {
  if (asQuickDropFlow) return <> {children} </>;
  return (
    <Flex gap={40} direction={{ base: "column", lg: "row" }}>
      <Box
        sx={{
          // Avoid flex overflowing when right side is too long
          minWidth: 0,
          flex: 2,
        }}
      >
        {children}
      </Box>

      <Box maw={256} miw={256} sx={{ flex: 1 }}>
        <CollectionPreview {...rest} />
      </Box>
    </Flex>
  );
};

export default memo(FormContentWithPreview);
